<template>
  <div>
    <div class="answer">
      <div class="topheng">
        <div class="lefttopclass">
          <span>姓名：{{ info.name }}</span>
        </div>
        <div class="lefttopclass">
          <span>倒计时：{{ showtime }}</span>
        </div>
      </div>
      <!-- <div class="title-top">
        <div class="top-height">
          <span>2023年上游新闻采编人员业务技能测试</span>
          <span>（第一场）</span>
        </div>
      </div> -->
      <div class="wrapper-intro1">
        <div class="suclass">
          <div class="hengclass">
            <div
              v-for="(item, index) in flatQuestions"
              :key="item.id"
              v-show="index === activeQuestionIndex"
              class="topickContent"
            >
              <div class="textdiy">
                <span>{{ item ? item.answer_type : '加载中...' }}</span>
                <div class="textclass"></div>
              </div>
              <div class="answercls">
                <div v-if="item.title.length > 200">
                  <textarea
                    class="textclass1"
                    rows="6"
                    cols="30"
                    maxlength="10000"
                    placeholder="题目描述不清楚，请联系人力资源部"
                    >{{ index + 1 + '、' + item.title }}</textarea
                  >
                </div>
                <div v-else>
                  {{ index + 1 + '、' + item.title }}
                </div>
                <div v-if="item.answer_type === '单选题'" class="contentclass">
                  <!-- checked = "item.userMarkedAnswer === 'A'" -->
                  <!-- this.flatQuestions[questionIndex].userMarkedAnswer item.userMarkedAnswer === chonsev.mark-->
                  <van-radio-group v-model="radio">
                    <van-radio
                      v-for="(chonsev, idx) in item.options"
                      v-show="chonsev.value"
                      :name="idx"
                      :key="idx + 'radiocheck'"
                      class="choseItem"
                      @click="onUserMark(chonsev, index)"
                      >{{ chonsev.value }}</van-radio
                    >
                  </van-radio-group>
                </div>
                <div v-if="item.answer_type === '多选题'" class="contentclass">
                  <van-checkbox-group v-model="choseresult">
                    <van-checkbox
                      v-for="(chonsev1, idx1) in item.options"
                      v-show="chonsev1.value"
                      :name="idx1"
                      :key="idx1 + 'checkbox'"
                      class="choseItem"
                      @click="onUserMark(chonsev1, index)"
                      >{{ chonsev1.value }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
                <div v-if="item.answer_type === '判断题'" class="contentclass">
                  <van-radio-group v-model="radio">
                    <van-radio
                      v-for="(chonsev2, idx2) in item.options"
                      v-show="chonsev2.value"
                      :name="idx2"
                      :key="idx2 + 'check'"
                      class="choseItem"
                      @click="onUserMark(chonsev2, index)"
                      >{{ chonsev2.value }}</van-radio
                    >
                  </van-radio-group>
                </div>
                <div v-if="item.answer_type === '简答题'" class="contentclass">
                  <textarea
                    v-model="writeStr"
                    rows="8"
                    placeholder="请输入答案"
                  ></textarea>
                </div>
                <div v-if="item.answer_type === '策划题'" class="contentclass1">
                  <textarea
                    v-model="writeStr"
                    rows="8"
                    placeholder="请输入答案"
                  ></textarea>
                </div>
                <div class="btnclass">
                  <div class="btn-left" @click="nexttopic">上一题</div>
                  <div class="btn-right" @click="uptopic">
                    {{
                      activeQuestionIndex + 1 === flatQuestions.length
                        ? '完成'
                        : '下一题'
                    }}
                  </div>
                </div>
                <div class="commitimg">
                  <img
                    src="../assets/images/commitbtn.png"
                    @click="checkNoanswer"
                  />
                  <span>{{ activeQuestionIndex + 1 }}/24</span>
                </div>
                <!-- <div class="btn btn-start" @click="checkNoanswer">
                  交&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;卷
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ruleclass" v-html="content"></div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast, Picker } from 'vant';
import qs from 'qs';
import {
  answerList,
  uploadAnswerList,
  getBaseInfo,
  answerUpdate,
  checkScenenum,
} from '../api';
import { Checkbox, CheckboxGroup, RadioGroup, Radio } from 'vant';

Vue.use(Checkbox)
  .use(CheckboxGroup)
  .use(RadioGroup)
  .use(Radio)
  .use(Picker);

const datakey = 'nowCheckDate0816';
const dataInxkey = 'nowCheckDateIndex';
export default {
  filters: {
    text(value) {
      value = value.replace(/\((.+?)\)/g, `（&nbsp;&nbsp;&nbsp; ）`);
      return value;
    },
  },
  data() {
    return {
      content: '',
      info: {},
      voteInfo: {},
      day: 0,
      hour: '00',
      min: '00',
      second: '00',
      timerans: null,
      radio: -1,
      topicType: 1, //1是选择题目  2是多选题   3是判断题   4是简答题  5是策划题
      flatQuestions: [],
      questions: [],
      activeQuestionIndex: 0,
      writeStr: '', //填写答案的题目
      showtime: '',
      noanswernum: 0,
      choseresult: [],
      surecommit: '',
    };
  },
  async mounted() {
    if (!window.localStorage.getItem('userInfo0816')) {
      Toast('请先登录');
      this.$router.push('home');
      return false;
    }
    this.info = qs.parse(window.localStorage.getItem('userInfo0816'));
    const istrue = await checkScenenum(this.info.phone);
    if (istrue.code !== 200) {
      Toast(istrue.msg);
      this.$router.push('home');
      return false;
    }
    const infores = await getBaseInfo();
    if (infores.code === 200) {
      this.voteInfo = infores.data;
    }
    const nowtime = new Date().getTime();
    const endTime = parseInt(infores.data.endTime) * 1000;
    if (nowtime > endTime) {
      this.$router.push('rule');
    }
    this.countTime();
    this.getQuestionList();
  },
  watch: {
    showtime(newval, old) {
      if (parseInt(newval) > 0) {
        this.timerans = setInterval(() => {
          this.countTime();
        }, 1000);
      } else {
        this.forceSend();
      }
    },
    writeStr(newVal, nowVal) {
      if (newVal) {
        this.flatQuestions[
          this.activeQuestionIndex
        ].userMarkedAnswer[0] = newVal;
        window.localStorage.setItem(
          datakey,
          JSON.stringify(this.flatQuestions),
        );
        window.localStorage.setItem(dataInxkey, this.activeQuestionIndex);
      } else {
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer = [];
      }
    },
  },
  methods: {
    checkNoanswer() {
      // let str = '';
      let num = 0;
      for (let i = 0; i < this.flatQuestions.length; i++) {
        if (this.flatQuestions[i].userMarkedAnswer.length < 1) {
          // str += i + 1 + '、';
          num++;
        }
      }
      if (num > 0) {
        this.surecommit = '您还有' + num + '道题未完成，确认交卷吗？';
      } else {
        this.surecommit = '确定要提交试卷吗？';
      }
      this.$dialog
        .confirm({
          title: '温馨提醒',
          message: this.surecommit,
        })
        .then(() => {
          this.sendPaper();
        })
        .catch(() => {
          // console.log('取消');
        });
      return;
    },
    //强制交卷
    forceSend() {
      this.$dialog
        .confirm({
          title: '温馨提醒',
          message: '时间到了，请交卷！',
        })
        .then(() => {
          this.sendPaper();
        })
        .catch(() => {
          this.forceSend();
        });
      return;
    },
    // 发送答卷
    async sendPaper() {
      const userAnswers = {};
      this.flatQuestions.forEach((item) => {
        // console.log('userAnswers::' + userAnswers);
        userAnswers[item.id] = item.userMarkedAnswer.join('');
      });
      const data = {
        phone: this.info.phone,
        answer: JSON.stringify(userAnswers),
      };
      const ret = await answerUpdate(data);
      Toast(ret.msg);
      if (ret.code === 200) {
        setTimeout(() => {
          window.localStorage.removeItem(datakey);
          window.localStorage.removeItem(dataInxkey);
          this.$router.push('rule');
        }, 2000);
      }
    },
    uptopic() {
      if (this.activeQuestionIndex < this.flatQuestions.length - 1) {
        this.activeQuestionIndex++;
        if (
          this.flatQuestions[this.activeQuestionIndex].answer_type ===
            '单选题' ||
          this.flatQuestions[this.activeQuestionIndex].answer_type === '判断题'
        ) {
          this.formatIndex();
        } else if (
          this.flatQuestions[this.activeQuestionIndex].answer_type === '多选题'
        ) {
          this.formatMoreChose();
        } else if (
          this.flatQuestions[this.activeQuestionIndex].answer_type ===
            '简答题' ||
          this.flatQuestions[this.activeQuestionIndex].answer_type === '策划题'
        ) {
          this.writeStr = this.flatQuestions[
            this.activeQuestionIndex
          ].userMarkedAnswer[0];
        }
      } else {
        this.checkNoanswer();
      }
    },
    nexttopic() {
      if (this.activeQuestionIndex > 0) {
        this.activeQuestionIndex--;
        if (
          this.flatQuestions[this.activeQuestionIndex].answer_type ===
            '单选题' ||
          this.flatQuestions[this.activeQuestionIndex].answer_type === '判断题'
        ) {
          this.formatIndex();
        } else if (
          this.flatQuestions[this.activeQuestionIndex].answer_type === '多选题'
        ) {
          this.formatMoreChose();
        } else if (
          this.flatQuestions[this.activeQuestionIndex].answer_type ===
            '简答题' ||
          this.flatQuestions[this.activeQuestionIndex].answer_type === '策划题'
        ) {
          this.writeStr = this.flatQuestions[
            this.activeQuestionIndex
          ].userMarkedAnswer[0];
        }
      }
    },
    formatMoreChose() {
      this.choseresult = [];
      if (
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer.length ===
        0
      ) {
        return false;
      }
      for (
        var i = 0;
        i <
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer.length;
        i++
      ) {
        if (
          this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[i] ===
          'A'
        ) {
          this.choseresult.push(0);
        } else if (
          this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[i] ===
          'B'
        ) {
          this.choseresult.push(1);
        } else if (
          this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[i] ===
          'C'
        ) {
          this.choseresult.push(2);
        } else if (
          this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[i] ===
          'D'
        ) {
          this.choseresult.push(3);
        } else if (
          this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[i] ===
          'E'
        ) {
          this.choseresult.push(4);
        } else {
        }
      }
    },
    formatIndex() {
      if (
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer.length ===
        0
      ) {
        this.radio = -1;
        return false;
      }
      if (
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[0] === 'A'
      ) {
        this.radio = 0;
      } else if (
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[0] === 'B'
      ) {
        this.radio = 1;
      } else if (
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[0] === 'C'
      ) {
        this.radio = 2;
      } else if (
        this.flatQuestions[this.activeQuestionIndex].userMarkedAnswer[0] === 'D'
      ) {
        this.radio = 3;
      } else {
        this.radio = -1;
      }
    },
    async getQuestionList() {
      //如果本地缓存有就取本地缓存
      const cacheDate = window.localStorage.getItem(datakey);
      if (cacheDate) {
        this.flatQuestions = JSON.parse(cacheDate);
        this.activeQuestionIndex = parseInt(
          window.localStorage.getItem(dataInxkey),
        );
        return;
      }
      //如果数据库获取的新数据
      const retQuestions = await answerList(this.info.phone);
      // 扁平化数据
      const d2Arr = Object.values(retQuestions.data);
      const mappedData = d2Arr.map((groupItemArr, groupIndex) => {
        return groupItemArr.map((item, index) => {
          return {
            ...item,
            userMarkedAnswer: [],
            trueAnswer: '',
            options: [
              {
                mark: 'A',
                value: item.answer_a,
              },
              {
                mark: 'B',
                value: item.answer_b,
              },
              {
                mark: 'C',
                value: item.answer_c,
              },
              {
                mark: 'D',
                value: item.answer_d,
              },
              {
                mark: 'E',
                value: item.answer_e,
              },
            ],
            parentIndex: groupIndex,
          };
        });
      });
      this.questions = mappedData;
      const flatRet = mappedData.reduce((pre, next) => {
        return [...pre, ...next];
      }, []);
      this.flatQuestions = flatRet;
      window.localStorage.setItem(datakey, JSON.stringify(this.flatQuestions));
      window.localStorage.setItem(dataInxkey, this.activeQuestionIndex);
      const userAnswers = {};
      this.flatQuestions.forEach((item) => {
        userAnswers[item.id] = item.userMarkedAnswer.join(' ');
      });
      const datalist = {
        phone: this.info.phone,
        answerList: JSON.stringify(userAnswers),
      };
      const ret = await uploadAnswerList(datalist);
      if (ret.code !== 200) {
        Toast(ret.msg);
        setTimeout(() => {
          this.$router.push('rule');
        }, 2000);
      } else {
        if (
          this.flatQuestions[this.activeQuestionIndex].answer_type ===
            '单选题' ||
          this.flatQuestions[this.activeQuestionIndex].answer_type === '判断题'
        ) {
          this.formatIndex();
        } else if (
          this.flatQuestions[this.activeQuestionIndex].answer_type === '多选题'
        ) {
          this.formatMoreChose();
        } else if (
          this.flatQuestions[this.activeQuestionIndex].answer_type ===
            '简答题' ||
          this.flatQuestions[this.activeQuestionIndex].answer_type === '策划题'
        ) {
          this.writeStr = this.flatQuestions[
            this.activeQuestionIndex
          ].userMarkedAnswer;
        }
      }
    },
    // 用户标记答案
    /**
     * @param optionItem 答案选项
     * @param questionIndex 问题所在索引
     */
    onUserMark(optionItem, questionIndex) {
      const targetData = this.flatQuestions[questionIndex];
      // 处理多选题标记
      if (targetData.answer_type === '多选题') {
        // 如果用户已选，再标记时应移除选项
        if (targetData.userMarkedAnswer.includes(optionItem.mark)) {
          targetData.userMarkedAnswer = targetData.userMarkedAnswer.filter(
            (item) => item !== optionItem.mark,
          );
        } else {
          // 如果用户未选，则将其推入数组
          targetData.userMarkedAnswer.push(optionItem.mark);
          // 按照字母排序答案选项
          targetData.userMarkedAnswer = targetData.userMarkedAnswer.sort();
        }
      } else {
        // 处理单选题标记
        targetData.userMarkedAnswer = [optionItem.mark];
      }
      this.flatQuestions[questionIndex] = targetData;
      window.localStorage.setItem(datakey, JSON.stringify(this.flatQuestions));
      window.localStorage.setItem(dataInxkey, questionIndex + 1);
    },
    // 倒计时
    async countTime() {
      clearInterval(this.timerans);
      const endTime = this.voteInfo.endTime * 1000;
      const now = new Date().getTime();
      // 时间差
      let leftTime = endTime - now;
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.hour = h < 10 ? '0' + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? '0' + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? '0' + s : s;
      } else {
        this.day = 0;
        this.hour = '00';
        this.min = '00';
        this.second = '00';
      }
      this.showtime =
        (this.day > 0 ? this.day + '天' : '') +
        (this.hour > 0 ? this.hour + ':' : this.day > 0 ? '00:' : '') +
        (this.min > 0
          ? this.min + ':'
          : this.day > 0 || this.hour > 0
          ? '00:'
          : '') +
        (this.second > 0 ? this.second : '');
      // 等于0的时候不调用
      if (
        Number(this.day) === 0 &&
        Number(this.hour) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // this.timer = setInterval(() => {
        //   this.countTime();
        // }, 1000);
        // 递归每秒调用countTime方法，显示动态时间效果,
        // setTimeout(this.countTime, 1000);
      }
    },
  },
};
</script>
<style lang="less">
.answer {
  min-height: 100vh;
  background-image: url('../assets/images/bodyimg.jpg');
  background-size: cover;
  background-position: center;
}
.textclass1 {
  padding: 10px;
  width: 100%;
  height: 172.5px;
  border: 1px solid #e9e9e9;
  overflow-y: scroll;
  overflow-x: scroll;
}
.topheng {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  .lefttopclass {
    margin-top: -30px;
    width: 49%;
    color: #fff;
  }
}
.title-top {
  height: 200px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  .top-height {
    display: flex;
    flex-direction: column;
    text-align: center;
    line-height: 30px;
  }
}
.ruleclass {
  padding: 30px;
  color: #fff;
}
.wrapper-intro1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .suclass {
    height: 500px;
    width: 80%;
    background: rgba(233, 233, 233, 0.5);
    border-radius: 10px;
  }
  .hengclass {
    position: absolute;
    background: #fff;
    min-height: 480px;
    width: 90%;
    left: 5%;
    top: calc(4rem + 10px);
    border-radius: 10px;
    padding: 20px;
    text-align: left;
    .topickContent {
      .textdiy {
        height: 17px;
        .textclass {
          margin: -10px 0px;
          width: 28px;
          height: 13px;
          background: #428cff;
          opacity: 0.3;
        }
      }
      .answercls {
        padding-top: 20px;
        .btnclass {
          display: flex;
          flex-direction: row;
          width: 100%;
          justify-content: space-between;
          margin-top: 30px;
          .btn-left {
            display: inline-block;
            background-color: #83d0ff;
            color: #fff;
            border-radius: 18px;
            width: 40%;
            text-align: center;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
          }
          .btn-right {
            display: inline-block;
            background-color: #3a94ea;
            color: #fff;
            border-radius: 18px;
            width: 40%;
            text-align: center;
            height: 36px;
            line-height: 36px;
            font-size: 14px;
          }
        }
      }
      .contentclass {
        .choseItem {
          padding-top: 10px;
          width: 100%;
        }
        textarea {
          margin-top: 20px;
          padding: 10px;
          width: 100%;
          height: 220px;
          border: 1px solid #e9e9e9;
        }
      }
      .contentclass1 {
        .choseItem {
          padding-top: 10px;
          width: 100%;
        }
        textarea {
          margin-top: 20px;
          padding: 10px;
          width: 100%;
          height: 180px;
          border: 1px solid #e9e9e9;
        }
      }
    }
  }
  .title {
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
  }

  .explain {
    padding: 20px 0;
    color: rgb(24, 138, 213);
    letter-spacing: 3px;
    font-size: 16px;
    font-weight: 900;

    &::after {
      bottom: 20px !important;
      width: 260% !important;
      height: 20px;
    }
  }

  .chalk-style-text {
    position: relative;

    &::after {
      position: absolute;
      z-index: -1;
      left: 50%;
      bottom: 20px;
      display: block;
      height: 20px !important;
      width: 120%;
      background-color: #f5f1e6;
      transform: translateX(-50%);
      border-radius: 10px;
    }
  }
  .commitimg {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 10px;
    img {
      width: 50%;
    }
    span {
      font-weight: 700;
      text-align: right;
      line-height: 40px;
      width: 50%;
    }
  }
  .btn-start {
    margin-top: 30px;
    display: inline-block;
    background-color: red;
    color: #fff;
    border-radius: 20px;
    width: 60%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .desc {
    li {
      list-style-type: none;
      line-height: 1.5em;
      font-size: 16px;
    }
  }
}
</style>
